<template>
  <el-row class="industryBox">
    <div id="elecEchart" :style="{ width: '100%', height: '280px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted, ref} from 'vue'
import * as echarts from "echarts";
export default {
  name: "elecEchart",
  data(){
    return {
    }
  },
  setup() {
    /// 声明定义一下echart
    let areaName = ref('hlj');
    let echart = echarts;
    onMounted(() => {
      elecEchart();
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function elecEchart() {
      let chart = echart.init(document.getElementById("elecEchart"));
      // 把配置和数据放这里
      chart.setOption({
        tooltip: {
        trigger: 'axis',
            axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
         }
        },
        axisLabel: {
            color: '#fff',
            fontSize: '16px',
        },
        legend: {
            textStyle: {
               color: '#fff',      // 图例文字颜色
               fontSize: '14px'
            },
        },
        grid: {
            left: 0,
            right: '4%',
            bottom: 0,
            top: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            show: false,
            splitLine: {
            show: false,
          }
        },
        yAxis: {
            type: 'category',
            data: ['仪器仪表制造业','金属制品、机械','计算机、电子设备制造业','电气器材制造业','专用设备制造业','电子产品','通用设备制造业','非金属矿物制造业','化学原料、制品制造业','互联网和相关服务业'],
            inverse: true,
            axisLabel: {
            color: '#fff',
            fontSize: '14px',
            },
        },
        series: [
            {
            // name: '失效',
            type: 'bar',
            stack: 'total',
            label: {
                show: false
            },
            color: '#57c6c0',
            emphasis: {
                focus: 'series'
            },
            // data: [3342,1603,1245,1081,924,405,369,317,240,109]
            data: [3341,1798,1305,1244,1123,475,422,394,309,166]
            },
        ]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    return { elecEchart, areaName};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .tag{
  margin: 0 auto;
  margin-bottom: 10px;
 }
 .tag span{
  padding: 6px;
  cursor: pointer;
 }
 .tag span.active{
  color: #409eff;
  font-weight: 500;
 }
</style>
